import { Snackbar } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Alert } from "@material-ui/lab";
import { useAlert } from "contexts/AlertContext";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export function AlertMessage() {
  const styles = useStyles();
  const ref = React.useRef(null);
  const [state, dispatch] = useAlert();
  const close = () => dispatch({ message: null, severity: "info" });
  return (
    <div className={styles.root}>
      <Snackbar autoHideDuration={3000} open={Boolean(state.message)} onClose={close}>
        <Alert ref={ref} onClose={close} severity={state.severity}>
          {state.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
